<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';

  let {
    count = undefined,
    countTemplate = undefined,
    headingText,
    headingLevel = 'h2',
    quotes,
    link = undefined,
    headingClasses = $bindable(),
    dataTestId = 'marketing-social-proof',
  } = $props();

  headingClasses = headingClasses ? headingClasses : 'text-lg md:text-2xl xl:text-3xl';

  let countShoutOut = $state();
  if (count && countTemplate) {
    countShoutOut = countTemplate.replace(
      /{{COUNT}}/,
      `<strong class="text-blue-cerulean font-bold">${count}</strong>`
    );
  }
</script>

<div data-testid={dataTestId} class="mt-8 md:my-10 lg:my-14">
  <div class="mx-auto max-w-6xl px-4 flex flex-col items-center">
    {#if count && countTemplate}
      <div class=" mb-2 text-center text-base md:text-xl leading-normal text-blue-navy">
        {@html countShoutOut}
      </div>
    {/if}
    {#if headingText}
      <BaseHeading
        className={`text-center leading-tight font-medium text-blue-dark-navy mb-8 lg:mb-12 ${headingClasses}`}
        {headingLevel}
      >
        {headingText}
      </BaseHeading>
    {/if}
    <div
      class="grid gap-4 mb-4 sm:w-full md:w-auto sm:px-8 lg:px-0 lg:mb-0"
      class:md:grid-cols-2={quotes.length === 2}
      class:lg:grid-cols-3={quotes.length === 3}
    >
      {#each quotes as { quote, author, title, link }, i}
        <div class="lg:mx-2" class:sm:mr-auto={!(i % 2) && quotes.length > 1} class:sm:ml-auto={i % 2}>
          <div
            class="rounded-lg shadow-y-md bg-white pl-12 py-4 pr-4 relative leading-normal text-base
              text-gray-charcoal mb-2 lg:mb-4"
            class:max-w-88={quotes.length > 1}
            class:md:max-w-none={quotes.length > 1}
          >
            {quote}
            <div class="absolute top-0 left-0">
              <svg
                class="mt-3 ml-2 h-8 w-8 fill-current text-blue-bright-cyan"
                class:text-blue-cerulean={i === 1}
                class:text-purple={i === 2}
              >
                <use xlink:href={`${SPRITESHEET_URL}#quote`} />
              </svg>
            </div>
            <div
              class="absolute bg-white rotate-45 bottom-0 lg:left-1/2 w-4 h-4 translate-y-2 -translate-x-1/2
                shadow-quote-arrow"
              class:left-12={!(i % 2)}
              class:right-8={i % 2}
            ></div>
          </div>
          <div
            class="my-4 pt-2 lg:mb-0 lg:pt-4 lg:px-0"
            class:flex-row={!(i % 2)}
            class:flex-row-reverse={i % 2}
            class:pl-6={!(i % 2)}
            class:pr-6={i % 2}
          >
            <div
              class="text-sm leading-tight font-medium text-blue-navy lg:text-xl lg:text-center lg:mb-1"
              class:text-left={!(i % 2)}
              class:text-right={i % 2}
            >
              {author}
            </div>
            {#if link && link.text && link.url}
              <div
                class="text-sm font-rubik leading-tight text-gray-charcoal lg:text-center"
                class:text-left={!(i % 2)}
                class:text-right={i % 2}
              >
                {title},
                <BaseLink
                  className="text-sm leading-normal font-medium text-blue-cerulean hover-hover:hover:text-blue-darkish
                    hover-hover:hover:underline active:text-blue-darkish active:underline"
                  {...link}
                />
              </div>
            {:else}
              <div
                class="text-sm font-rubik leading-tight text-gray-charcoal lg:text-center"
                class:text-left={!(i % 2)}
                class:text-right={i % 2}
              >
                {title}
              </div>
            {/if}
          </div>
        </div>
      {/each}
    </div>
    {#if link && link.text && link.url}
      <div class="mt-6 w-auto lg:mt-12">
        <BaseLink
          className="text-sm leading-normal font-medium text-blue-cerulean md:text-xl hover-hover:hover:text-blue-darkish
          hover-hover:hover:underline active:text-blue-darkish active:underline group inline-flex justify-start flex-row w-auto"
          {...link}
        >
          <span>{link.text}</span>
          <svg
            class="ml-3 h-3 w-3 md:h-5 md:w-5 mt-1 md:mt-1.25 fill-current text-blue-cerulean
              hover-hover:group-hover:text-blue-darkish group-active:text-blue-darkish"
          >
            <use xlink:href={`${SPRITESHEET_URL}#right-arrow`} />
          </svg>
        </BaseLink>
      </div>
    {/if}
  </div>
</div>
